import { useTranslation } from 'react-i18next';
import hhLogo from '@/assets/images/wreg/hh-logo-h-red.svg';

type Props = {
  light?: boolean;
};

const RLogo = ({ light }: Props) => {
  const { t } = useTranslation();
  return (
    <span className={`rg-logo${light ? ' rg-logo-light' : ''}`}>
      <img className="rg-logo-svg" src={hhLogo} alt={t('wreg.logo.alt')} />
    </span>
  );
};

export { RLogo };
